import { supabase } from '../supabaseClient';

export const REVIEW_SESSION_THRESHOLD_MS = 10000;

/** Topics in the BSI grid: other baskets only, excluding the topic being placed. */
export const countReviewableGridTopics = (baskets, currentBasketId, studyingTopicId) => {
  if (!baskets?.length) return 0;

  return baskets
    .filter((basket) => basket.id !== currentBasketId)
    .flatMap((basket) => basket.topics || [])
    .filter((t) => t.id !== studyingTopicId).length;
};

/** BSI actions: other-basket topics, or the topic being placed when the grid is otherwise empty. */
export const countBsiReviewableTopics = (baskets, currentBasketId, studyingTopicId) => {
  const gridCount = countReviewableGridTopics(baskets, currentBasketId, studyingTopicId);
  if (gridCount > 0) return gridCount;
  if (studyingTopicId) return 1;
  return 0;
};

/** Topics available to revisit during workspace search (in baskets, else unplaced). */
export const countWorkspaceReviewTopics = (baskets, topics = []) => {
  const inBaskets = (baskets || []).reduce(
    (sum, basket) => sum + (basket.topics?.length || 0),
    0
  );
  if (inBaskets > 0) return inBaskets;
  return (topics || []).filter((topic) => !topic.basket_id).length;
};

export const trackReviewSession = async ({ userId, workspaceId, reviewableTopicCount }) => {
  if (!userId || !workspaceId) return;
  if (!reviewableTopicCount || reviewableTopicCount <= 0) return;

  const { error } = await supabase.rpc('log_bsi_review_session', {
    p_workspace_id: workspaceId,
    p_user_id: userId,
  });

  if (error) {
    console.warn('[trackReviewSession] log_bsi_review_session failed', error);
  }
};

export const trackBsiReviewSession = async ({
  userId,
  workspaceId,
  timeSpentMs,
  reviewableTopicCount,
  force = false,
}) => {
  if (!force && timeSpentMs < REVIEW_SESSION_THRESHOLD_MS) return false;

  await trackReviewSession({
    userId,
    workspaceId,
    reviewableTopicCount,
  });
  return true;
};
